<div class="header">
  <div class="pl-0" fxLayout="row" fxFlexAlign="start" dir="ltr" fxLayoutGap="5px">
      <div *ngFor='let tab of wizardTabs; index as tabIndex;'>
          <a [ngClass]="{'underline':tabIndex ===currentIndex , 'disabled': tabIndex !==currentIndex}" class="btn btn-light wizard-button"
              (click)='wizardButtonClick(tabIndex)'>{{tab}}</a>
      </div>
  </div>
  <div class="border header">
      <div class="content-container">
          <ng-content select="[sample]" class="row-6"></ng-content>
      </div>
  </div>
</div>
